<form [formGroup]="form" class="app-install-trigger-form app-use-trigger-form">

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
    generateHint="Sandbox app-state permissions, app version, and locale will be generated with plausible defaults. The test runner backdates this row's updated_at to match the flow's Time Since App Use interval."
    specifyHint="These values are saved to the sandbox app-device state and control permission/version/locale conditions. The app-use timestamp is derived from the selected flow's interval."
  ></app-flow-test-app-state-section>

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>
</form>
